import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "i18n"

// Material UI
import { makeStyles } from "@material-ui/core/styles"
import { Grid, Typography, Paper } from "@material-ui/core"
import { green } from "@material-ui/core/colors"

// Icons
import CheckIcon from "@material-ui/icons/Check"

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(3),
    border: `solid 0.5px ${theme.palette.primary.main}`
  },
  icon: {
    fontSize: "1.3rem",
    marginRight: theme.spacing(1),
    color: green[500]
  },
  fontWeightBolder: {
    fontWeight: theme.typography.fontWeightBolder
  },
  flex: {
    display: "flex"
  },
  clamp: {
    display: "-webkit-box",
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical",
    overflow: "hidden"
  }
}))

export default function KnowledgeGainedCard({ items }) {
  const { t } = useTranslation()

  const classes = useStyles()

  return (
    <Paper className={classes.paper}>
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <Typography variant="h6" className="text-bold">
            {t("What knowledge will you gain?")}
          </Typography>
        </Grid>

        <Grid item>
          <Grid container spacing={2}>
            {items.map((value, index) => (
              <Grid item sm={6} key={index}>
                <div className={classes.flex}>
                  <CheckIcon className={classes.icon} fontSize="large" />
                  <Typography
                    className={classes.clamp}
                    display="inline"
                    variant="body1"
                  >
                    {value}
                  </Typography>
                </div>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  )
}

KnowledgeGainedCard.propTypes = {
  items: PropTypes.array.isRequired
}

KnowledgeGainedCard.defaultProps = {
  items: []
}
